// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__ULIzY","errors":"Errors_errors__Z6gle"};